import { RefineThemes } from "@refinedev/antd";
import type { ThemeConfig } from "antd";
import { theme as antTheme } from "antd";
import type { ConfigProviderProps } from "antd/es/config-provider";

const defaultToken = antTheme.getDesignToken();
export const theme = {
  ...RefineThemes.Magenta,
  token: {
    colorPrimary: "#00AFCC",
    colorLink: "#00AFCC",
    borderRadiusLG: 4,
    colorBgLayout: "#F2F7F7",
    borderRadius: 2,
    colorError: "#FF4D4F",
    fontSize: 14,
  },
  components: {
    Card: {
      headerFontSize: 20,
      headerHeight: 64,
    },
    Collapse: {
      contentBg: defaultToken.colorBorderSecondary,
    },
    Layout: {
      bodyBg: "#F2F7F7",
    },
    Modal: { fontWeightStrong: 500, titleFontSize: 18 },
    Typography: {
      titleMarginTop: "0.5rem",
      titleMarginBottom: 0,
      colorText: "rgba(0, 0, 0, 0.65)",
    },
    Table: {
      borderRadiusLG: 0,
      rowSelectedBg: "#E6F7FF",
      rowSelectedHoverBg: "#ABE3FD",
    },
  },
} satisfies ThemeConfig;

export const nonPaddingCollapse = {
  components: {
    Collapse: {
      contentPadding: "16px 0",
      contentBg: defaultToken.colorBorderSecondary,
    },
  },
} satisfies ThemeConfig;

export const formConfig = {
  validateMessages: {
    required: "${label}は必須です。",
    types: {
      email: "${label}の形式が正しくありません。",
    },
    string: {
      max: "最大${max}桁のキャラクタのみ",
    },
  },
} satisfies ConfigProviderProps["form"];
